export default __webpack_public_path__ + "static/media/org-program-form-builder.ed1ec757.png";